import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { GenericApiService } from "../../generic-api/generic-api.service";
import { QueryParams } from "../../../../interfaces/generic-api.interface";
import { CIPSettings } from "src/environments/environment";
import { CIPRequest, CIPRequestRecord } from "src/app/shared/datasource/interfaces/CIP/cip-requests.interface";

@Injectable({
  providedIn: 'root'
})
export class CIPRequestsService  extends GenericApiService{

  httpClient = inject(HttpClient)

  getDefaultHeaders() : HttpHeaders{
    const headers = new HttpHeaders()
    .set('Accept', '*/*')
    .set('Content-Type', 'application/json')

    return headers
  }

  getRequests (search? : string) : Observable<CIPRequest[]> {
    const headers = this.getDefaultHeaders()
    const url     = `${CIPSettings.baseUrl}/${CIPSettings.endPoints["requests"]}`
    const query: QueryParams = {
      ...(search && { filter: search })
    };

    return this.get<CIPRequest[]>(url, headers, query)
  }

  getRequestDetails(CIPId : string) : Observable<CIPRequestRecord> {
    const headers = this.getDefaultHeaders()
    const url     = `${CIPSettings.baseUrl}/${CIPSettings.endPoints["requestDetails"]}`
    const query: QueryParams = {
      cipId   : CIPId
    }
    return this.get<CIPRequestRecord>(url, headers, query)
  }

}
